import { PerformanceGoalsAssigneeSelectFieldDocument } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

export const AssigneeSelectField: React.FC<{
  value: EmployeeForSelectFragmentNoAccess[]
  error?: string
  touched?: boolean
  onChange: (value: EmployeeForSelectFragmentNoAccess[]) => void
}> = ({ value, onChange, error, touched }) => {
  const { data, loading } = useQuery(PerformanceGoalsAssigneeSelectFieldDocument)
  const employees = data?.goals.employees ?? []

  return (
    <EmployeeSelector
      label={i18n.t('performance_goals.assignee_select_field.label')}
      emptyLabel={i18n.t('performance_goals.assignee_select_field.placeholder')}
      employeeIds={employees.map((employee) => employee.id)}
      error={touched ? error : undefined}
      value={value}
      disabled={loading}
      onSelect={onChange}
      hideSearchIcon
      multiple
    />
  )
}
